// Create Character Page Entry Point
import '../../js/config.js';
import '../../js/initSideNav.js';
import '../../js/translations.js';
import '../../js/utils/TokenManager.js';
import '../../js/create/imageGeneration.js';
import '../../js/create/forms/characterForm.js';
import '../../js/create/recruitCharacter.js';
import '../../js/create/recruitFieldEditWands.js';
